import { render, staticRenderFns } from "./ViewQuestionnaire.vue?vue&type=template&id=b13a3ec2&scoped=true&"
import script from "./ViewQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./ViewQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./ViewQuestionnaire.vue?vue&type=style&index=0&id=b13a3ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13a3ec2",
  null
  
)

export default component.exports